import { SET_LIBRARIES, SET_GENERAL_LIBRARIES } from '../actions/actionTypes';

const initialState = {
    list: [],
    generalList: [],
  };
  
export const libraryReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_LIBRARIES:
            return {
                ...state,
                list: action.payload,
            };
        case SET_GENERAL_LIBRARIES:
            return {
                ...state,
                generalList: action.payload,
            };
        default:
            return state
    }
};